<mat-select [(ngModel)]="selection" multiple   (selectionChange)="setValue($event)"> 
    <mat-option *ngFor="let option of options" [value]="option.name">
      <!-- {{option.eventType}} - {{option.jobScheduleID}} -->
      {{option.name}}
    </mat-option>
  </mat-select>  